import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Link, UncontrolledTooltip} from 'reactstrap';
import MarkdownRenderer from '../../../utility/MarkDownRenderer';

const Query_Explanation = ({ explanation }) => {
     const [modal_large, setmodal_large] = useState(false);
        function tog_large() {
            setmodal_large(!modal_large);
        }
  return (
    <>
    <Button className="btn rounded-pill" color="primary" id="qe" onClick={() => tog_large(true)}>
        <i className='ri-information-line'></i>
    </Button>
    <UncontrolledTooltip
                                                placement="left"
                                                target="qe"
                                                className="leftmore"
                                                id="quer_exp"
                                              >
                                                Query Explanation
                                              </UncontrolledTooltip>

            <Modal
                size="lg"
                isOpen={modal_large}
                toggle={() => {
                    tog_large();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myLargeModalLabel" toggle={() => {
                        tog_large();
                    }}>

                    Query Explanation

                </ModalHeader>
                <ModalBody>
                    <MarkdownRenderer markdown={explanation}/>
                    {/* <textarea value={explanation} disabled={true} className="form-control" id="exampleFormControlTextarea5" rows="7"></textarea> */}
                    
                </ModalBody>
                {/* <div className="modal-footer">
                    <Button className="btn btn-light" onClick={() => setmodal_large(false)}><i className="ri-close-line me-1 align-middle"></i> Close</Button>
                    <Button color="primary">Save changes</Button>
                </div> */}
            </Modal>
    </>
  )
}

export default Query_Explanation